import React from 'react';
import { Modal, ModalHeader, ModalBody, ModalFooter, Button } from "reactstrap";
import CustomHeader from "../../../Components/Common/CustomHeader";

type ConfirmationModalProps = {
    isOpen: boolean;
    onToggle: () => void;
    onConfirm: () => void;
    templateName: string | null;
    filters: any;
    totalCustomers: number;
    isLoading: boolean;
};

const formatFilters = (filters: any) => {
    const activeFilters = Object.entries(filters)
        .filter(([, value]) => value)
        .map(([key, value]) => `${key}: ${value}`);

    return activeFilters.length > 0 ? activeFilters.join(', ') : 'Ninguno';
};

export const ConfirmationModal: React.FC<ConfirmationModalProps> = ({
    isOpen,
    onToggle,
    onConfirm,
    templateName,
    filters,
    totalCustomers,
    isLoading
}) => {
    return (
        <Modal isOpen={isOpen} toggle={onToggle} centered contentClassName="border-0 rounded-4 shadow overflow-hidden">
            <CustomHeader title="Confirmar Envío Masivo" onClose={onToggle} component={ModalHeader} />
            <ModalBody className="px-4 py-4">
                <div className="text-center mb-4">
                    <div className="avatar-md mx-auto mb-3">
                        <div className="avatar-title bg-warning-subtle text-warning rounded-circle fs-1">
                            <i className="ri-alert-line"></i>
                        </div>
                    </div>
                    <h5 className="mb-2">¿Confirmar envío masivo?</h5>
                    <p className="text-muted mb-0">Estás a punto de enviar una plantilla. Esta acción no se puede deshacer.</p>
                </div>

                <div className="bg-light rounded p-3 border border-light-subtle">
                    <h6 className="fs-13 fw-semibold text-uppercase text-muted mb-3">Resumen de Envío</h6>
                    <ul className="list-unstyled mb-0">
                        <li className="mb-2 pb-2 border-bottom border-light-subtle d-flex justify-content-between">
                            <span className="text-muted"><i className="ri-chat-smile-2-line align-middle me-1"></i> Plantilla</span>
                            <span className="fw-medium text-dark">{templateName || 'N/A'}</span>
                        </li>
                        <li className="mb-2 pb-2 border-bottom border-light-subtle d-flex justify-content-between">
                            <span className="text-muted"><i className="ri-filter-2-line align-middle me-1"></i> Filtros</span>
                            <span className="fw-medium text-dark text-end" style={{ maxWidth: '60%' }}>{formatFilters(filters)}</span>
                        </li>
                        <li className="d-flex justify-content-between">
                            <span className="text-muted"><i className="ri-user-3-line align-middle me-1"></i> Destinatarios</span>
                            <span className="badge bg-primary fs-12 align-self-center px-2 py-1">{totalCustomers}</span>
                        </li>
                    </ul>
                </div>
            </ModalBody>
            <ModalFooter>
                <Button color="light" onClick={onToggle} disabled={isLoading}>
                    Cancelar
                </Button>
                <Button color="primary" onClick={onConfirm} disabled={isLoading}>
                    {isLoading ? 'Enviando...' : 'Sí, continuar'}
                </Button>
            </ModalFooter>
        </Modal>
    );
};
